/**
 * ASCII Hero Engine - Default Constants & Character Sets
 */

// Default palette of chromatic glitch colors
export const DEFAULT_GLITCH_COLORS = [
  "#ff7120", // vibrant orange
  "#ffffff", // white
  "#000000", // black
  "#ff2a6d", // Neon Crimson / Magenta
  "#ffb703", // Solar Amber
  "#00f59b", // Emerald Mint
  "#9d4edd", // Cyber Violet
  "#ff7b00", // Warm Orange
];

// Default normalized polygon mask for the mid-grey accent zone (from side-profile.svg)
export const DEFAULT_MID_GREY_MASK = [
  [0.76497, 0.42569],
  [0.80924, 0.41343],
  [0.80625, 0.55394],
  [0.73086, 0.66019],
  [0.65807, 0.66019],
  [0.64779, 0.59954],
  [0.65807, 0.55903],
  [0.69440, 0.51667],
  [0.64779, 0.47824],
  [0.66940, 0.46204],
  [0.71055, 0.50116],
];

// Normalized polygon mask for the project showcase mid-grey accent zone (from project-showcase.temp.svg)
export const PROJECT_SHOWCASE_MID_GREY_MASK = [
  [0.58581, 0.57593],
  [0.54714, 0.27523],
  [0.72826, 0.11944],
  [0.80729, 0.37546],
  [0.84062, 0.19190],
  [0.84740, 0.18889],
  [0.88177, 0.21852],
  [0.88646, 0.23218],
  [0.84935, 0.42384],
  [0.83854, 0.42801],
  [0.81081, 0.38773],
  [0.80872, 0.38125],
  [0.72878, 0.12176],
  [0.75534, 0.37986],
];

// Standard character ramps & glitch sets
export const DEFAULT_BASE_RAMP = [" ", "·", ":", "-", "=", "+", "*", "x", "%", "#", "@", "M", "B", "$"];
export const DEFAULT_BASE_GLITCH = ["0", "1", "<", ">", "/", "\\", "{", "}", "[", "]", "*", "+", "#", "X", "~"];

// Ambient ASCII dust character sets
export const DEFAULT_DUST_CHARS = ["·", "•", ":", "+", "*", "-", "~", "^", "°", "x", "0", "1", "<", ">", "/", "§", "o", "."];

// Curly / textured character sets for the mid-grey accent zone
export const DEFAULT_MID_GREY_RAMP = ["~", "c", "e", "s", "3", "§", "&", "ç", "@", "8", "%", "S", "C", "o", "9", "6", "≈"];
export const DEFAULT_MID_GREY_GLITCH = ["~", "§", "&", "ç", "@", "8", "c", "s", "3", "S", "e", "o", "%", "≈", "6", "9"];

// Default Star SVG Path from star.svg
export const STAR_SVG_PATH = "M144.186 106.785C144.186 47.8462 154.409 0 167.001 0C179.594 0 189.817 47.8462 189.817 106.785C227.711 61.6333 266.303 31.5494 275.957 39.6464C285.601 47.7352 262.668 90.9602 224.773 136.112C282.828 125.873 331.74 127.633 333.924 140.025C336.116 152.425 290.751 170.801 232.697 181.034C283.754 210.505 320.086 243.281 313.789 254.183C307.5 265.085 260.932 250.016 209.88 220.545C230.043 275.922 236.806 324.382 224.974 328.693C213.14 332.996 187.164 291.526 167.001 236.149C146.838 291.526 120.861 332.996 109.029 328.693C97.1955 324.382 103.96 275.922 124.123 220.545C73.0694 250.016 26.5066 265.084 20.2111 254.183C13.9155 243.281 50.2524 210.505 101.307 181.034C43.2501 170.801 -2.10979 152.425 0.075778 140.025C2.26298 127.633 51.173 125.873 109.228 136.112C71.3344 90.9602 48.4014 47.7352 58.0479 39.6464C67.6945 31.5494 106.292 61.6333 144.186 106.785Z";
